import { render, staticRenderFns } from "./FolderWidget.vue?vue&type=template&id=efd30726"
import script from "./FolderWidget.vue?vue&type=script&lang=js"
export * from "./FolderWidget.vue?vue&type=script&lang=js"
import style0 from "./FolderWidget.vue?vue&type=style&index=0&id=efd30726&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports